import React from 'react'
import styled, { css } from 'styled-components'

type Props = {
  htmlFor?: string
  color?: string
  disabled?: boolean
  className?: string
}

export const Label = ({
  htmlFor,
  color,
  disabled,
  children,
  className,
}: WithChildren<Props>): JSX.Element => {
  return (
    <Wrapper
      htmlFor={htmlFor}
      className={className}
      color={color}
      disabled={disabled}
    >
      {children}
    </Wrapper>
  )
}

type WrapperProps = Pick<Props, 'color' | 'disabled'>

const Wrapper = styled.label<WrapperProps>`
  display: block;
  font-size: 1rem;
  color: ${({ color, theme }) => color || theme.color.primari.grigioEstra};
  margin-bottom: 0.5rem;
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.7;
        `
      : null}
`
